<div [formGroup]="phoneForm" class="d-flex gap-2">
    <select formControlName="country" class="form-select" style="width: 130px; text-align-last: center;">
        <option *ngFor="let country of countries" [value]="country.isoCode">
            {{ country.isoCode }} ({{ country.dialCode }})
        </option>
    </select>

    <input [readonly]="readonly" formControlName="phoneNumber" class="form-control" type="tel"
        placeholder="Telefon Numarası" />
</div>